"use strict";

exports.__esModule = true;
exports.alertWidgets = void 0;
var _Widgets = require("../Components/Widgets");
var alertWidgets = exports.alertWidgets = function alertWidgets() {
  return [_Widgets.DataTableWidget, _Widgets.DataTableColumnWidget, _Widgets.ReportWidget];
};